import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategorySection() {
  return (
    <section id="categories" className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-800 mb-3">分类浏览</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">选择你感兴趣的内容分类，快速找到适合你的哺乳育儿漫画</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 text-center hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all">
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-heading text-foreground-800 mb-1 whitespace-nowrap">{cat.name}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed hidden sm:block">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}